import type { OutsideRecordSummary } from '../../services/api/types.gen';
import { formatDateTimeInAgencyZone } from '../../utils/dateUtils';

/** Who completed it and when, e.g. "Jake Streb, 10/29/2026 12:34 PM". */
export const outsideRecordByline = (outsideRecord: OutsideRecordSummary) =>
  [
    outsideRecord.completed_by_name,
    formatDateTimeInAgencyZone(outsideRecord.completed_at),
  ]
    .filter(Boolean)
    .join(', ');
